/**
 * Icelandic króna.
 */
export var ISK = {
  code: 'ISK',
  base: 10,
  exponent: 0
};